import {baseVue as Vue} from 'lvgs-vue-modules';
import errorTrackerPlugin from 'errorTrackerPlugin';
import imageUrlFormatterMixin from 'imageUrlFormatterMixin';
import scoutMixin from 'scoutMixin';

/** Set Plugin */
Vue.use(errorTrackerPlugin);

/** Set Mixin */
Vue.mixin(imageUrlFormatterMixin);
// 全フォームVue設定(formVueLp*)が共通でimportするため、ここで一括登録する
Vue.mixin(scoutMixin);

const enabledDebugPerformance = process.env.DEBUG_VUE_PERFORMANCE_ENABLED === 'true';
Vue.config.performance = enabledDebugPerformance;

export default Vue;
